import { useEffect, useState } from 'react';

function useWindowSize(): { width: number; height: number } {
    /* If the user rotates the device/resizes, we want to redraw. So any changes to windowSize below will trigger a render & reset rubaway state */
    const [windowSize, setWindowSize] = useState<{ width: number; height: number }>({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const updateWindowSize = () => {
            setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        };

        window.addEventListener('resize', updateWindowSize);

        return () => {
            window.removeEventListener('resize', updateWindowSize);
        };
    }, []);

    return windowSize;
}

export default useWindowSize;
